import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Home from '../pages/Home';
import About from '../pages/About';
import Contact from '../pages/Contact';
import Solutions from '../pages/Solutions';
import Technology from '../pages/Technology';
import Pharma from '../pages/Pharma';
import Training from '../pages/Training';
import NotFound from '../pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'solutions',
        element: <Solutions />,
      },
      {
        path: 'technology',
        element: <Technology />,
      },
      {
        path: 'our-work',
        element: <Navigate to="/technology" replace />,
      },
      {
        path: 'work',
        element: <Navigate to="/technology" replace />,
      },
      {
        path: 'about',
        element: <About />,
      },
      {
        path: 'contact',
        element: <Contact />,
      },
      {
        path: 'pharma',
        element: <Pharma />,
      },
      {
        path: 'training',
        element: <Training />,
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]); 
